/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const CniIcon = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="5" width="20" height="14" rx="2"/><circle cx="8" cy="12" r="2"/><path d="M14 9h4M14 12h4M14 15h2"/></svg>;
const SelfieIcon = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const DocIcon = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="12" y2="17"/></svg>;
const LockIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#534AB7" strokeWidth="1.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>;

export default function HostDocsPage({ onNavigate }) {
  const [files, setFiles]               = useState({ cni_recto: null, cni_verso: null, selfie: null, assurance: null, kbis: null });
  const [previews, setPreviews]         = useState({ cni_recto: null, cni_verso: null, selfie: null, assurance: null, kbis: null });
  const [uploadedUrls, setUploadedUrls] = useState({ cni_recto: null, cni_verso: null, selfie: null, assurance: null, kbis: null });
  const [uploading, setUploading]       = useState(false);
  const [cguAccepted, setCguAccepted]   = useState(false);
  const [charteAccepted, setCharteAccepted] = useState(false);
  const [submitted, setSubmitted]       = useState(false);
  const [errors, setErrors]             = useState({});
  const [user, setUser]                 = useState(null);
  const [isManager, setIsManager]       = useState(false);

  const inputRefs = {
    cni_recto: useRef(), cni_verso: useRef(),
    selfie: useRef(), assurance: useRef(), kbis: useRef(),
  };

  useEffect(() => {
    supabase.auth.getSession().then(async ({ data: { session } }) => {
      const u = session?.user ?? null;
      setUser(u);
      if (u) {
        const { data: profile } = await supabase
          .from('host_profiles').select('is_manager').eq('id', u.id).single();
        setIsManager(profile?.is_manager === true);
      }
    });
  }, []);

  // Docs dynamiques selon le profil
  const DOCS = [
    { key: 'cni_recto', label: "Pièce d'identité (recto)", sublabel: 'CNI ou passeport — face avant',           Icon: CniIcon,    required: true  },
    { key: 'cni_verso', label: "Pièce d'identité (verso)", sublabel: 'CNI — face arrière (passeport : page 2)', Icon: CniIcon,    required: true  },
    { key: 'selfie',    label: "Selfie avec votre pièce",  sublabel: 'Visage visible + document lisible',        Icon: SelfieIcon, required: true  },
    ...(isManager
      ? [{ key: 'kbis',      label: 'Kbis de la société',    sublabel: 'Extrait Kbis de moins de 3 mois — obligatoire',          Icon: DocIcon, required: true  }]
      : [{ key: 'assurance', label: 'Attestation assurance', sublabel: 'Recommandée — location saisonnière (optionnelle)',        Icon: DocIcon, required: false }]
    ),
  ];

  const handleFile = (key, file) => {
    if (!file) return;
    const preview = URL.createObjectURL(file);
    setFiles(prev => ({ ...prev, [key]: file }));
    setPreviews(prev => ({ ...prev, [key]: preview }));
    setErrors(prev => ({ ...prev, [key]: null }));
  };

  const handleDrop = (key, e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) handleFile(key, file);
  };

  const validate = () => {
    const newErrors = {};
    if (!cguAccepted)    newErrors.cgu    = 'Vous devez accepter les CGU';
    if (!charteAccepted) newErrors.charte = 'Vous devez accepter la charte de qualité';
    const hasAtLeastOne = DOCS.some(doc => files[doc.key]);
    if (!hasAtLeastOne) newErrors.general = 'Veuillez joindre au moins un document';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const uploadFile = async (key, file, userId) => {
    const ext  = file.name.split('.').pop();
    const path = `${userId}/${key}_${Date.now()}.${ext}`;
    const { error } = await supabase.storage
      .from('hostdocuments')
      .upload(path, file, { upsert: true, contentType: file.type });
    if (error) throw error;
    return path;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    if (!user) { onNavigate('auth'); return; }
    setUploading(true);
    try {
      const paths = {};
      for (const doc of DOCS) {
        if (files[doc.key]) {
          paths[doc.key] = await uploadFile(doc.key, files[doc.key], user.id);
        }
      }
      setUploadedUrls(paths);

      const missingDocs = DOCS.filter(d => d.required && !paths[d.key]).map(d => d.label);

      const { error: updateError } = await supabase.from('host_profiles').update({
        status: 'pending',
        docs: {
          cni:       !!(paths.cni_recto && paths.cni_verso),
          selfie:    !!paths.selfie,
          assurance: !!paths.assurance,
          kbis:      !!paths.kbis,
          rib:       false,
        },
        doc_urls: {
          cni_recto: paths.cni_recto || null,
          cni_verso: paths.cni_verso || null,
          selfie:    paths.selfie    || null,
          assurance: paths.assurance || null,
          kbis:      paths.kbis      || null,
        },
        cgu_accepted:    true,
        charte_accepted: true,
        updated_at:      new Date().toISOString(),
      }).eq('id', user.id);

      if (updateError) throw new Error(`Mise à jour échouée : ${updateError.message}`);

      const { data: hostProfile } = await supabase
        .from('host_profiles')
        .select('full_name, email')
        .eq('id', user.id)
        .single();

      const hostName  = hostProfile?.full_name || user.user_metadata?.full_name || 'Hôte';
      const hostEmail = hostProfile?.email || user.email;

      await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'docs_submitted',
          to: 'contact@havenly.fr',
          data: {
            hostName,
            hostEmail,
            hostId: user.id,
            docsSubmitted: Object.keys(paths).join(', '),
            missingDocs: missingDocs.join(', ') || 'Aucun',
          }
        })
      }).catch(e => console.error('Admin notification error:', e));

      await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'docs_received',
          to: hostEmail,
          data: { name: hostName.split(' ')[0] || 'Hôte' }
        })
      }).catch(e => console.error('Host confirmation email error:', e));

      setSubmitted(true);
    } catch (err) {
      console.error('Upload error:', err);
      setErrors({ submit: `Erreur lors de l'envoi : ${err.message}` });
    } finally {
      setUploading(false);
    }
  };

  const openDoc = async (path) => {
    if (!path) return;
    const { data } = await supabase.storage.from('hostdocuments').createSignedUrl(path, 60);
    if (data?.signedUrl) window.open(data.signedUrl, '_blank');
  };

  if (submitted) return (
    <div style={{ background: 'var(--surface)', minHeight: '100vh', paddingTop: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ maxWidth: 520, textAlign: 'center', padding: '2rem' }}>
        <div style={{ width: 80, height: 80, borderRadius: '50%', background: 'var(--green-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', fontSize: 36 }}>✓</div>
        <h2 style={{ fontFamily: 'var(--serif)', fontSize: 28, letterSpacing: '-0.5px', marginBottom: 12 }}>Dossier envoyé !</h2>
        <p style={{ fontSize: 15, color: 'var(--ink-3)', lineHeight: 1.8, marginBottom: 32 }}>
          Vos documents sont en cours de vérification. Vous recevrez une confirmation sous <strong>24h</strong>.
        </p>
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 14, padding: 20, marginBottom: 24, textAlign: 'left' }}>
          {DOCS.map(doc => (
            <div key={doc.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14 }}>
                <doc.Icon />
                <span>{doc.label}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {uploadedUrls[doc.key] && (
                  <button onClick={() => openDoc(uploadedUrls[doc.key])}
                    style={{ fontSize: 11, color: '#534AB7', textDecoration: 'underline', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'var(--sans)' }}>
                    Voir →
                  </button>
                )}
                <span style={{ fontSize: 12, color: '#C4784A', fontWeight: 500 }}>En vérification</span>
              </div>
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14 }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>
              <span>CGU & Charte acceptées</span>
            </div>
            <span style={{ fontSize: 12, color: 'var(--green-mid)', fontWeight: 500 }}>Validé ✓</span>
          </div>
        </div>
        <button onClick={() => onNavigate('dashboard')} style={{ padding: '12px 32px', background: 'var(--green)', color: '#fff', border: 'none', borderRadius: 24, fontSize: 15, fontWeight: 500, cursor: 'pointer', fontFamily: 'var(--sans)' }}>
          Aller au dashboard →
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ background: 'var(--surface)', minHeight: '100vh', paddingTop: 60 }}>
      <div style={{ background: 'var(--white)', borderBottom: '1px solid var(--border)', padding: '16px 2rem' }}>
        <div style={{ maxWidth: 640, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 style={{ fontFamily: 'var(--serif)', fontSize: 20, letterSpacing: '-0.5px', marginBottom: 2 }}>Vérification de votre identité</h1>
            <p style={{ fontSize: 13, color: 'var(--ink-3)' }}>
              {isManager ? 'Documents requis pour activer votre conciergerie' : 'Dernière étape avant l\'activation de votre annonce'}
            </p>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {[1,2,3].map((_, i) => <div key={i} style={{ width: 8, height: 8, borderRadius: '50%', background: i < 2 ? 'var(--green)' : 'var(--ink)' }} />)}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 640, margin: '0 auto', padding: '2rem' }}>

        {!user && (
          <div style={{ background: '#EEEDFE', border: '1px solid #AFA9EC', borderRadius: 12, padding: '12px 16px', marginBottom: 20, fontSize: 13, color: '#534AB7' }}>
            <strong style={{ fontWeight: 500 }}>Connexion requise</strong> —{' '}
            <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => onNavigate('auth')}>Connectez-vous</span>{' '}
            pour soumettre vos documents.
          </div>
        )}

        {/* Bannière conciergerie */}
        {isManager && (
          <div style={{ background: '#FDF8F4', border: '1px solid #E8A87C', borderRadius: 12, padding: '14px 18px', marginBottom: 20, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C4784A" strokeWidth="1.5" style={{ flexShrink: 0, marginTop: 1 }}><path d="M3 21V9l9-6 9 6v12"/><path d="M9 21V13h6v8"/></svg>
            <div>
              <div style={{ fontSize: 13, fontWeight: 500, color: '#C4784A', marginBottom: 3 }}>Documents conciergerie</div>
              <p style={{ fontSize: 12, color: '#8B5A3A', lineHeight: 1.6, margin: 0 }}>
                En tant que conciergerie, un Kbis de moins de 3 mois est requis en plus de votre pièce d'identité. Ces documents ne sont demandés qu'une seule fois.
              </p>
            </div>
          </div>
        )}

        <div style={{ background: '#EEEDFE', border: '1px solid #AFA9EC', borderRadius: 12, padding: '14px 18px', marginBottom: 24, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          <span style={{ flexShrink: 0 }}><LockIcon /></span>
          <div>
            <div style={{ fontSize: 13, fontWeight: 500, color: '#3C3489', marginBottom: 4 }}>Pourquoi ces documents ?</div>
            <p style={{ fontSize: 13, color: '#534AB7', lineHeight: 1.6, margin: 0 }}>
              Havenly vérifie l'identité de chaque hôte pour protéger les voyageurs. Vos documents sont stockés de façon sécurisée et ne sont jamais partagés.
              <strong style={{ fontWeight: 500 }}> Ces documents ne vous seront demandés qu'une seule fois.</strong>
            </p>
          </div>
        </div>

        {errors.submit && (
          <div style={{ background: '#FCEBEB', border: '1px solid #F09595', borderRadius: 10, padding: '12px 16px', marginBottom: 16, fontSize: 13, color: '#A32D2D' }}>
            {errors.submit}
          </div>
        )}

        {errors.general && (
          <div style={{ background: '#FCEBEB', border: '1px solid #F09595', borderRadius: 10, padding: '12px 16px', marginBottom: 16, fontSize: 13, color: '#A32D2D' }}>
            {errors.general}
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 24 }}>
          {DOCS.map(doc => (
            <div key={doc.key} style={{ background: 'var(--white)', border: `1px solid ${errors[doc.key] ? '#F09595' : files[doc.key] ? 'var(--green)' : 'var(--border)'}`, borderRadius: 14, overflow: 'hidden' }}>
              <div style={{ padding: '16px 20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                  <doc.Icon />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 8 }}>
                      {doc.label}
                      {doc.required
                        ? <span style={{ color: '#E24B4A', marginLeft: 2 }}>*</span>
                        : <span style={{ fontSize: 11, background: '#FDF0E6', color: '#C4784A', padding: '2px 8px', borderRadius: 20, fontWeight: 500 }}>Optionnel</span>
                      }
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 2 }}>{doc.sublabel}</div>
                  </div>
                  {files[doc.key] && (
                    <span style={{ fontSize: 12, background: '#E8F5F0', color: '#0F6E56', padding: '3px 10px', borderRadius: 20, fontWeight: 500 }}>✓ Ajouté</span>
                  )}
                </div>

                {/* Avertissement assurance (hôtes uniquement) */}
                {doc.key === 'assurance' && !files[doc.key] && (
                  <div style={{ background: '#FDF0E6', border: '1px solid #E8A87C', borderRadius: 8, padding: '10px 14px', marginBottom: 12, display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C4784A" strokeWidth="2" style={{ flexShrink: 0, marginTop: 1 }}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    <div style={{ fontSize: 12, color: '#C4784A', lineHeight: 1.6 }}>
                      <strong style={{ fontWeight: 500 }}>Recommandé :</strong> sans attestation d'assurance couvrant la location saisonnière, vous n'êtes pas couvert en cas de sinistre grave. Votre assurance habitation classique ne couvre pas automatiquement les dégâts causés par vos voyageurs.
                    </div>
                  </div>
                )}

                {/* Avertissement Kbis (conciergeries uniquement) */}
                {doc.key === 'kbis' && !files[doc.key] && (
                  <div style={{ background: '#FDF0E6', border: '1px solid #E8A87C', borderRadius: 8, padding: '10px 14px', marginBottom: 12, display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C4784A" strokeWidth="2" style={{ flexShrink: 0, marginTop: 1 }}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    <div style={{ fontSize: 12, color: '#C4784A', lineHeight: 1.6 }}>
                      <strong style={{ fontWeight: 500 }}>Obligatoire :</strong> le Kbis doit dater de moins de 3 mois. Il sera vérifié manuellement par l'équipe Havenly sous 24h.
                    </div>
                  </div>
                )}

                <div
                  onDragOver={e => e.preventDefault()}
                  onDrop={e => handleDrop(doc.key, e)}
                  onClick={() => inputRefs[doc.key].current.click()}
                  style={{ border: `2px dashed ${files[doc.key] ? 'var(--green)' : 'var(--border-2)'}`, borderRadius: 10, padding: '20px', textAlign: 'center', cursor: 'pointer', background: files[doc.key] ? 'var(--green-light)' : 'var(--surface)' }}>
                  {previews[doc.key] ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent: 'center' }}>
                      <img src={previews[doc.key]} alt="" style={{ height: 60, borderRadius: 6, objectFit: 'cover' }} onError={e => e.target.style.display = 'none'} />
                      <div style={{ textAlign: 'left' }}>
                        <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--green-mid)' }}>Document chargé</div>
                        <div style={{ fontSize: 12, color: 'var(--ink-3)' }}>{files[doc.key].name}</div>
                        <div style={{ fontSize: 11, color: 'var(--ink-4)', marginTop: 2 }}>Cliquez pour remplacer</div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontSize: 28, marginBottom: 8 }}>📎</div>
                      <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 4 }}>Glissez votre fichier ici ou cliquez pour parcourir</div>
                      <div style={{ fontSize: 12, color: 'var(--ink-4)' }}>JPG, PNG ou PDF — max 10 Mo</div>
                    </div>
                  )}
                </div>
                <input ref={inputRefs[doc.key]} type="file" accept="image/*,.pdf" style={{ display: 'none' }}
                  onChange={e => handleFile(doc.key, e.target.files[0])} />
                {errors[doc.key] && <div style={{ fontSize: 12, color: '#A32D2D', marginTop: 8 }}>⚠ {errors[doc.key]}</div>}
              </div>
            </div>
          ))}
        </div>

        {/* CGU + Charte */}
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 14, padding: '20px', marginBottom: 24, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <h3 style={{ fontSize: 15, fontWeight: 500, marginBottom: 4 }}>Engagements obligatoires</h3>
          <label style={{ display: 'flex', gap: 12, cursor: 'pointer', alignItems: 'flex-start' }}>
            <input type="checkbox" checked={cguAccepted} onChange={e => { setCguAccepted(e.target.checked); setErrors(prev => ({ ...prev, cgu: null })); }}
              style={{ accentColor: 'var(--green)', width: 16, height: 16, marginTop: 2, flexShrink: 0 }} />
            <div>
              <div style={{ fontSize: 13, fontWeight: 500 }}>
                J'accepte les <span style={{ color: 'var(--green)', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => onNavigate('legal', 'cgu')}>CGU</span> et la <span style={{ color: 'var(--green)', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => onNavigate('legal', 'confidentialite')}>Politique de confidentialité</span>
                <span style={{ color: '#E24B4A', marginLeft: 4 }}>*</span>
              </div>
              <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 3, lineHeight: 1.5 }}>En acceptant, vous confirmez que toutes les informations fournies sont exactes.</div>
            </div>
          </label>
          {errors.cgu && <div style={{ fontSize: 12, color: '#A32D2D', marginLeft: 28 }}>⚠ {errors.cgu}</div>}
          <div style={{ height: 1, background: 'var(--border)' }} />
          <label style={{ display: 'flex', gap: 12, cursor: 'pointer', alignItems: 'flex-start' }}>
            <input type="checkbox" checked={charteAccepted} onChange={e => { setCharteAccepted(e.target.checked); setErrors(prev => ({ ...prev, charte: null })); }}
              style={{ accentColor: 'var(--green)', width: 16, height: 16, marginTop: 2, flexShrink: 0 }} />
            <div>
              <div style={{ fontSize: 13, fontWeight: 500 }}>J'accepte la <span style={{ color: 'var(--green)', textDecoration: 'underline', cursor: 'pointer' }}>Charte de qualité Havenly</span><span style={{ color: '#E24B4A', marginLeft: 4 }}>*</span></div>
              <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 3, lineHeight: 1.5 }}>Je m'engage à maintenir mon logement conforme aux photos, à répondre sous 2h, et à respecter les règles.</div>
            </div>
          </label>
          {errors.charte && <div style={{ fontSize: 12, color: '#A32D2D', marginLeft: 28 }}>⚠ {errors.charte}</div>}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <button onClick={() => onNavigate('newlisting')} style={{ padding: '11px 24px', background: 'transparent', color: 'var(--ink-3)', border: '1px solid var(--border)', borderRadius: 24, fontSize: 14, cursor: 'pointer', fontFamily: 'var(--sans)' }}>
            ← Retour
          </button>
          <button onClick={handleSubmit} disabled={uploading || !user}
            style={{ padding: '13px 32px', background: uploading || !user ? 'var(--border)' : 'var(--green)', color: '#fff', border: 'none', borderRadius: 24, fontSize: 15, fontWeight: 500, cursor: uploading || !user ? 'default' : 'pointer', fontFamily: 'var(--sans)', display: 'flex', alignItems: 'center', gap: 8 }}>
            {uploading
              ? <><div style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.4)', borderTop: '2px solid #fff', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />Envoi en cours...</>
              : 'Soumettre mon dossier →'}
          </button>
        </div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
